<template>
  <div>
    <v-snackbar
      v-model="snackbarDetails.show"
      :top="true"
      :center="true"
      :color="snackbarDetails.color"
      :timeout="10000">

      <div class="dvSnackbar-content">
        <div v-show="checkIcon != ''" class="dvSnackbar-content_icon">
          <span :class="checkIcon"></span>
        </div>
        <div class="dvSnackbar-content_text">
          {{ snackbarDetails.msg }}
        </div>
      </div>

      <v-btn
        text
        @click="snackbarDetails.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: 'referral-card-view',
    props: ['snackbarDetails'],
    data: () => ({
      snackbar: {
        timeout: 10000,
        color: 'sb-success'
      },
    }),
    computed: {
      checkIcon(){
        let retVal = ''
        if(this.snackbarDetails.color == 'sb-success'){
          retVal = 'icon-action_check_circle'
        }else if(this.snackbarDetails.color == 'sb-pending'){
          retVal = 'icon-content_status'
        }else if(this.snackbarDetails.color == 'sb-failed'){
          retVal = 'icon-action_close'
        }

        return retVal
      }
    },
    methods: {

    },
    mounted() {
    },
    components: {
    }
  }
</script>
